<template>
  <div class="h-full overflow-y-auto overflow-x-hidden">
    <!-- 设备基础信息 -->
    <div>
      <el-form
        :model="deviceBasicInfo"
        label-position="top"
        :inline="true"
        class="info-form mt-15px"
      >
        <el-row>
          <el-col :span="12">
            <el-form-item label="设备名称" class="mr-24px">
              <el-input v-model="deviceBasicInfo.name" class="w-140px" readonly></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="KKS编码" class="ml-24px mr-0px">
              <el-input v-model="deviceBasicInfo.deviceCode" class="w-140px" readonly></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="机组" class="mr-24px">
              <el-input v-model="deviceBasicInfo.unit" class="w-140px" readonly></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="专业" class="ml-24px mr-0px">
              <el-input v-model="deviceBasicInfo.speciality" class="w-140px" readonly></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <!-- <el-form-item label="型号" class="mr-24px">
          <el-input v-model="deviceBasicInfo.specification" class="w-140px" readonly></el-input>
        </el-form-item>
        <el-form-item label="生产厂家" class="ml-24px mr-0px">
          <el-input v-model="deviceBasicInfo.manufacturer" class="w-140px" readonly></el-input>
        </el-form-item> -->
      </el-form>
    </div>
    <!-- 设备属性 -->
    <CardTitle :title="'设备属性'" cardType="default"></CardTitle>
    <el-table
      :data="propsData"
      :height="`calc(30% - 40px)`"
      highlight-current-row
      element-loading-background="rgba(0, 0, 0, 0.5)"
    >
      <!-- <el-table-column type="index" label="序号" min-width="20" align="center">
        <template slot-scope="scope">{{ scope.$index + 1 }}</template>
      </el-table-column> -->
      <el-table-column prop="name" label="设备信息名称" min-width="50%"></el-table-column>
      <el-table-column prop="value" label="值" min-width="50%"></el-table-column>
    </el-table>
    <!-- 设备设计图纸 -->
    <CardTitle :title="'设备设计图纸'" cardType="default"></CardTitle>
    <el-table
      :data="docTableData"
      :height="`calc(30% - 40px)`"
      :v-loading="loading"
      highlight-current-row
      element-loading-background="rgba(0, 0, 0, 0.5)"
    >
      <el-table-column type="index" label="序号" min-width="20" align="center">
        <template slot-scope="scope">{{ scope.$index + 1 }}</template>
      </el-table-column>
      <el-table-column prop="fileName" label="文件名称" min-width="80"></el-table-column>
      <el-table-column prop="value1" label="操作" min-width="30" align="center">
        <template slot-scope="scope">
          <span @click="viewFile(scope.row)" class="cursor-pointer">查看</span>
        </template>
      </el-table-column>
    </el-table>
    <!-- 设备技术参数 -->
    <CardTitle :title="'设备技术参数'" cardType="default"></CardTitle>
    <el-table
      :data="technicalTableData"
      :height="`calc(30% - 40px)`"
      highlight-current-row
      element-loading-background="rgba(0, 0, 0, 0.5)"
    >
      <el-table-column type="index" label="序号" min-width="20" align="center">
        <template slot-scope="scope">{{ scope.$index + 1 }}</template>
      </el-table-column>
      <el-table-column prop="name" label="设备参数名称" min-width="80"></el-table-column>
      <el-table-column prop="value" label="设计值" min-width="40"></el-table-column>
    </el-table>

    <file-view-dialog
      v-if="fileViewDialogVisible"
      @close="closeFileViewDialog"
      :fileSrc="viewFileSrc"
    ></file-view-dialog>

    <!-- 左侧菜单 -->
    <DeviceLedgerTabList
      @changeTab="changeTab"
      activeTab="DeviceRealBasicInfo"
      :collapsePanel="collapsePanel"
    ></DeviceLedgerTabList>
  </div>
</template>

<script>
import { DeviceExtraInfoApi } from '@wiz-api/huizhou2-business'
import { EquipmentRfidApi, HandoverManageApi } from '@wiz-api/huizhou2'
import CardTitle from '@/components/cockpit/CardTitle'
import FileViewDialog from './components/FileViewDialog'
import DeviceLedgerTabList from './DeviceLedgerTabList'

const deviceExtraInfoApi = new DeviceExtraInfoApi()
const equipmentRfidApi = new EquipmentRfidApi()
const handoverManageApi = new HandoverManageApi()

export default {
  name: 'DeviceRealTimeInfo',
  components: {
    CardTitle,
    FileViewDialog,
    DeviceLedgerTabList,
  },
  props: {
    transferProps: {
      type: Object,
      defalut: () => {
        return {}
      },
    },
    collapsePanel: {
      type: Boolean,
      default: false,
    },
  },
  watch: {
    transferProps: {
      handler(newVal) {
        this.getDeviceBaseInfo()
        this.getFileList()
        this.getSiteId()
        if (newVal.isFromJump) {
          this.showDeviceModel(newVal.code)
        }
      },
      deep: true,
      immediate: true,
    },
  },
  data() {
    return {
      deviceBasicInfo: {},
      technicalTableData: [],
      docTableData: [],
      fileViewDialogVisible: false,
      propsData: [],
    }
  },
  methods: {
    changeTab(data) {
      const openEvent = new CustomEvent('openComponent', {
        detail: {
          toCom: {
            code: data.code,
            origin: data.origin,
            name: data.name,
            hideTitle: data.hideTitle,
          },
          position: 'right',
          type: 'tags',
          props: this.transferProps,
        },
      })
      window.dispatchEvent(openEvent)
    },
    // 获取设备基本信息
    async getDeviceBaseInfo() {
      const [err, res] = await deviceExtraInfoApi.getDeviceExtraInfoList({
        deviceCode: this.transferProps.code,
      })
      if (!err && res) {
        // 基础信息
        this.deviceBasicInfo = res.deviceBasicInfo
        // 接口返回数据存在缺失，基础数据使用表格中的数据
        this.setDeviceData()
        // 技术参数
        this.technicalTableData = res.mainTechnicalParameters
      }
    },
    // 表格赋值设备数据
    setDeviceData() {
      this.deviceBasicInfo.name = this.transferProps.name
      this.deviceBasicInfo.deviceCode = this.transferProps.code
      this.deviceBasicInfo.unit = this.transferProps.unit
      this.deviceBasicInfo.speciality = this.transferProps.major
    },
    // 获取文件列表
    async getFileList() {
      this.loading = true
      const [err, res] = await equipmentRfidApi.getEquipmentFiles({
        kkscode: this.getKksCode(this.transferProps.code),
      })
      if (!err) {
        this.docTableData = res
      }
      this.loading = false
    },
    // 查看文件
    viewFile(file) {
      const fileUrl = _.get(
        Wiz,
        'globalSettings.dynamicModules.modules["visualization-cockpit"].config'
      )?.deviceDocumentUrl
      if (fileUrl) {
        // window.open(`${fileUrl}${file.md5}`, '_blanck')
        this.viewFileSrc = `${fileUrl}${file.md5}`
        this.fileViewDialogVisible = true
      }
    },
    closeFileViewDialog() {
      this.fileViewDialogVisible = false
    },
    openFileViewDialog(row) {
      this.viewFileSrc = row.src
      this.fileViewDialogVisible = true
    },
    // 通过code获取位号
    async getSiteId() {
      const params = {
        code: this.getKksCode(this.transferProps.code),
      }
      const [err, res] = await handoverManageApi.getTagByCode1(params)
      const jsonRes = JSON.parse(res)
      if (!err && jsonRes) {
        this.propsData = []
        // 基本属性
        this.propsData.push({
          name: '名称',
          value: jsonRes.data.name,
        })
        this.propsData.push({
          name: '编码',
          value: jsonRes.data.code,
        })
        this.propsData.push({
          name: '类别',
          value: jsonRes.data.className,
        })
        this.propsData.push({
          name: '短描述',
          value: jsonRes.data.shortDescription,
        })
        this.propsData.push({
          name: '长描述',
          value: jsonRes.data.longDescription,
        })
        // 通用属性
        /* eslint-disable */
        if (jsonRes.data.tagAttributeTemplates) {
          for (let item of jsonRes.data.tagAttributeTemplates[0].tagAttributeTemplateDetail) {
            let deviceProp = {
              name: item.displayName,
              value: '',
            }
            for (let valueItem of jsonRes.data.tagAttributeTemplates[0]
              .tagAttributeTemplateValues) {
              for (let valueKey in valueItem) {
                if (item.fieldName === valueKey) {
                  deviceProp.value = valueItem[valueKey]
                }
              }
            }
            this.propsData.push(deviceProp)
          }
        }
        // 对数据进行排序，有值的排在前面
        this.propsData.sort((a, b) => {
          if (a.value && !b.value) {
            return -1 // a.value 有值，排在前面
          } else if (!a.value && b.value) {
            return 1 // b.value 有值，排在前面
          } else {
            return 0 // 两者都有值或都为空，保持顺序
          }
        })
        /* eslint-enable */
      }
    },
    // 根据设备code跳转到三维对应设备
    async showDeviceModel(code) {
      if (!player || !player.Native) return
      player.Native.ModelTree.setSelectItemNoEvent(0)
      await player.Native.Settings.set('color.pickup.bkAlpha', 'float', '1')
      const codeInfo = await player.Native.ModelTree.getItemByCode(this.getKksCode(code))
      if (codeInfo && codeInfo.item) {
        player.Native.Camera.moveToItem(codeInfo.item, 1)
        await player.Native.ModelTree.setSelectItemNoEvent(codeInfo.item)
      }
    },
  },
  computed: {
    getKksCode() {
      return (kksCode) => {
        const prefix = kksCode.slice(0, 4)
        if (prefix === '6760') {
          return kksCode.slice(4, kksCode.length)
        }
        return kksCode
      }
    },
  },
  created() {},
  beforeDestroy() {},
}
</script>

<style lang="scss" scoped>
::v-deep {
  .el-table {
    font-size: 13px;
    .cell {
      line-height: 14px;
    }
  }
}

::v-deep {
  .info-form {
    .el-form-item {
      margin-bottom: 15px;
    }
    .el-form-item__label {
      line-height: 20px;
      padding-bottom: 5px;
    }
    .el-input {
      .el-input__inner {
        border-color: #fff !important;
      }
    }
  }
}
</style>
